import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
  return (
    <div className="Perks p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Benefits of Collaborating with an Expert WordPress Development
              Company
            </h2>
            <p>
              Collaborating with an expert WordPress development company ensures
              high proficiency, personalized solutions, efficient projects,
              proactive problem-solving, and strong technical support for
              success. Here are the details on why you should collaborate with
              an expert WordPress development company:
            </p>
          </Col>
        </Row>
        <Row className="h-100 perks-padd">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>Modern Technology Integration</h4>
                <p>
                  Expert WordPress developers integrate modern technologies,
                  ensuring your project remains current, competitive, and
                  technologically advanced for effective performance and
                  longevity.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
            <div className="perks-box">
              <div className="perks-content">
                <h4>
                  Customized <br />
                  Solutions
                </h4>
                <p>
                  Craft personalized solutions, ensuring unique outcomes that
                  precisely match your project requirements and goals.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4>
                  Scalability <br />
                  Solutions
                </h4>
                <p>
                  Collaborate with a skilled WordPress agency for smooth growth
                  with scalable solutions that adapt effortlessly to business
                  demands.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="perks-box">
              <div className="perks-content">
                <h4>Ensuring Complete Transparency</h4>
                <p>
                  Partner with a custom WordPress agency for transparent
                  communication, building trust, and ensuring project goals are
                  met.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Perks;
